import type { PanelComponentSpec } from '@src/types/LayoutConfig';
import type { IDockviewPanelProps } from 'dockview';
import type { FunctionComponent } from 'react';
import { DEALER_ENTITY_ADMIN_PANEL_COMPONENTS } from './Dealer/entityAdmin';
import { SIGNALS_PANEL_COMPONENTS } from './Intel/intel';
import { MONITORING_PANEL_COMPONENTS } from './Monitoring/monitoring';
import { BLOTTER_PANEL_COMPONENTS } from './Trading/blotters/blotters';
import {
  CUSTOMER_ADMIN_PANEL_COMPONENTS,
  CUSTOMER_BUYING_POWER_PANEL_COMPONENTS,
  CUSTOMER_MONITORING_PANEL_COMPONENTS,
} from './Trading/customer';
import { MAIN_PANEL_COMPONENTS } from './Trading/main';
import { SYMBOL_PANEL_COMPONENTS } from './Trading/symbol';

/**
 * All possible panels seen in the AppLayout (FlexLayout or not) mechanism
 * - filter in/out with additions to useEnabledPanelTypes()
 *
 * Dealer add-panel groups: Monitoring blotters, then Ref Data EntityAdmin panels.
 */
export const PANEL_COMPONENTS_LIST: PanelComponentSpec[] = [
  ...MAIN_PANEL_COMPONENTS,
  ...BLOTTER_PANEL_COMPONENTS,
  ...CUSTOMER_MONITORING_PANEL_COMPONENTS,
  ...CUSTOMER_BUYING_POWER_PANEL_COMPONENTS,
  ...CUSTOMER_ADMIN_PANEL_COMPONENTS,
  ...DEALER_ENTITY_ADMIN_PANEL_COMPONENTS,
  ...SYMBOL_PANEL_COMPONENTS,
  ...MONITORING_PANEL_COMPONENTS,
  ...SIGNALS_PANEL_COMPONENTS,
] as const;

export const PANEL_COMPONENTS_MAP = PANEL_COMPONENTS_LIST.reduce(
  (res: Record<string, PanelComponentSpec>, component: PanelComponentSpec) => {
    res[component.type] = component;
    return res;
  },
  {}
);

export const PANEL_COMPONENTS = PANEL_COMPONENTS_LIST.reduce(
  (res: Record<string, FunctionComponent<IDockviewPanelProps>>, component: PanelComponentSpec) => {
    if (component.renderer) {
      res[component.type] = component.renderer;
    }
    return res;
  },
  {}
);
